<script setup>
import IconsComp from '@/components/IconsComp'
</script>
<template>
    <div class="mb-4">
        <p>
            O seguinte formulário é a primeira etapa do processo de seleção de projetos de inovação do Núcleo de Inovação
            Tecnológica do Hospital das Clínicas da FMUSP, InovaHC.
        </p>
        <p class="mt-4">
            Todos os campos serão analisados em conformidade com os critérios de seleção.
        </p>
        <p class="my-4">Este formulário está dividido em 4 seções:</p>
        <p>1. Informações do responsável pelo projeto;</p>
        <p>2. Informações do projeto;</p>
        <p>3. Estágio de desenvolvimento do projeto;</p>
        <p>4. Pitch deck do projeto.</p>

        <div class="flex items-center">
            <a href="/modelo-pitch.pdf" target="_blank"
                class="btn secondary flex items-center no-underline cursor-pointer">
                Baixar modelo do pitch
                <IconsComp icon="download" class="fill-green-500 w-6 h-6 ml-4" />
            </a>
        </div>
    </div>

    <div class="mb-8">
        <p class="mb-4">
            Enviaremos um feedback com informações sobre a inscrição do projeto no seu e-mail de contato!
        </p>
        <p>
            Declaramos que as informações sensíveis que forem reveladas pelas partes são protegidas por nosso compromisso
            com sigilo e confidencialidade.
        </p>
        <div class="text-3xl font-poppins font-bold text-purple-800 mb-2">
            Serão rejeitados projetos que:
        </div>
        <ul class="!list-disc px-6">
            <li>
                Não apresentam evidências de atendimento de necessidades do público alvo;
            </li>
            <li>
                Não apresentam evidências de relevância para saúde pública;
            </li>
            <li>
                Propõe vender ao HC produtos finalizados e/ou comercializados.
            </li>
        </ul>
    </div>
    <slot></slot>
    <div class="border-t border-purple-100 mb-16"></div>
    <div class="mt-14 text-xl font-poppins text-purple-500 mb-2 relative flex">
        Dúvidas?
    </div>
    <p>Escreva para inova@hc.fm.usp.br ou <a href="https://inovahc.hc.fm.usp.br/">visite nosso site</a></p>
</template>